// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".itemRow[data-v-59645103] {\n  margin-top: 5px;\n}", ""]);
// Exports
module.exports = exports;
